import { Instance, types } from "mobx-state-tree";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { LeadTagsUpdatePayload } from "@fidget/common/models/chat/chatItems";
import { tagGroupsStoreGetter } from "../../../utils";
import { ChatItemType } from "../ChatItemType";
import { BaseChatItem } from "./BaseChatItem";
import { notEmpty } from "@fidget/common/utils/not-empty";

export const TagsChangeChatItem = types
  .compose(
    "TagsChangeChatItem",
    BaseChatItem,
    types.model({
      type: types.literal(ChatItemType.TagsChange),
      eventData: types.frozen<LeadTagsUpdatePayload>()
    })
  )
  .views(tagGroupsStoreGetter)
  .views((self) => ({
    get text() {
      const { oldTagGroupId, oldTags, tags, tagGroupId, unknownTags } = self.eventData;

      const oldTagGroupName = oldTagGroupId && self.tagGroupsStore.getById(oldTagGroupId)?.name;
      const tagGroupName = tagGroupId && self.tagGroupsStore.getById(tagGroupId)?.name;

      const tagsChangeText = intl.formatMessage("conversation.event.tagsChange", {
        oldTags: oldTags.length
          ? `[${oldTags.join(", ")}]`
          : intl.formatMessage("conversation.event.tagsChange.tagsUndefined"),
        tags: tags.length
          ? `[${tags.join(", ")}]`
          : intl.formatMessage("conversation.event.tagsChange.tagsUndefined"),
        oldTagGroup:
          oldTagGroupName || intl.formatMessage("conversation.event.tagsChange.tagGroupUndefined"),
        tagGroup:
          tagGroupName || intl.formatMessage("conversation.event.tagsChange.tagGroupUndefined")
      });
      const tagGroupChangedToUndefinedReason =
        (!tagGroupName || undefined) &&
        intl.formatMessage("conversation.event.tagsChange.tagGroupUndefinedReason");
      const unknownTagsText =
        unknownTags &&
        intl.formatMessage("conversation.event.tagsChange.unknownTagsUsed", {
          unknownTags: `[${unknownTags.join(", ")}]`
        });

      return [tagsChangeText, tagGroupChangedToUndefinedReason, unknownTagsText].filter(notEmpty).join(" ");
    }
  }));

export interface ITagsChangeChatItem extends Instance<typeof TagsChangeChatItem> { }
